/* Forever Beside Me - decides when the Klaviyo welcome popup opens.
 * The Klaviyo form uses a "custom JavaScript" trigger, so it never opens by itself.
 *  - Not personalizing yet: open once they look interested - MIN_TIME on the page AND
 *    scrolled through MIN_SCROLL of it, or MAX_TIME on the page either way.
 *  - Started personalizing: wait until their preview is ready, then open after
 *    AFTER_PREVIEW of no activity (never while uploading, rendering, typing or
 *    while a drawer / dialog is open).
 *  - Something in the cart, or added to cart on this page: never.
 * Debug: add ?fbm_popup_debug=1 to the URL. */
(function () {
  'use strict';

  var FORM_ID = 'UyXPLg';
  var MIN_TIME = 30000;
  var MIN_SCROLL = 0.5;
  var MAX_TIME = 60000;
  var AFTER_PREVIEW = 7000;
  var CLOSE_DAYS = 3;
  var KEY = 'fbm_popup';

  var script = document.currentScript;
  var cartCount = parseInt(script && script.dataset.cartCount, 10) || 0;
  var debug = /[?&]fbm_popup_debug=1/.test(location.search);
  var testDelay = debug && location.search.match(/[?&]fbm_popup_first=(\d+)/);
  if (testDelay) { MIN_TIME = +testDelay[1]; MAX_TIME = 2 * MIN_TIME; }
  function log() { if (debug) console.log.apply(console, ['[fbm-popup]'].concat([].slice.call(arguments))); }

  function readStore(store) { try { return JSON.parse(store.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function writeStore(store, patch) {
    try { var v = readStore(store); for (var k in patch) v[k] = patch[k]; store.setItem(KEY, JSON.stringify(v)); } catch (e) { /* storage blocked */ }
  }

  // Klaviyo pins the "Get 10% off" teaser to the bottom edge; on phones lift it above our sticky buy bars.
  var teaserCss = document.createElement('style');
  teaserCss.textContent = '[class*="kl-teaser-"]{transition:bottom .25s ease}' +
    '@media (max-width:989px){body:has(.plp-sticky.is-visible,.fbm-pf-sticky.is-visible) [class*="kl-teaser-"]{bottom:84px!important}}';
  document.head.appendChild(teaserCss);

  var state = { stopped: '', engaged: false, busy: false, previewReady: false, opened: false };
  window.fbmPopup = { state: state };

  function stop(reason) {
    if (state.stopped) return;
    state.stopped = reason;
    clearTimeout(firstTimer); clearTimeout(maxTimer); clearTimeout(quietTimer); clearInterval(retryTimer);
    log('stopped:', reason);
  }

  // Klaviyo reports what happens to the form; remember closes and sign-ups ourselves too.
  window.addEventListener('klaviyoForms', function (e) {
    var d = e.detail || {};
    if (d.formId && d.formId !== FORM_ID) return;
    if (d.type === 'open') { state.opened = true; writeStore(sessionStorage, { shown: 1 }); }
    if (d.type === 'close') writeStore(localStorage, { closedAt: Date.now() });
    if (d.type === 'submit' || d.type === 'stepSubmit') {
      log('klaviyo', d.type, d.metaData ? Object.keys(d.metaData) : '');
      // "Yes, please!" is also a Klaviyo submit (no email yet) - only an email means they signed up.
      if (d.metaData && d.metaData.$email) writeStore(localStorage, { submitted: 1 });
      watchForCode();
    }
  });

  /* ---------- Apply the welcome code for them (Shopify keeps it in a cookie until checkout) ---------- */
  var CODE_RE = /^(?=.*\d)[A-Z0-9][A-Z0-9_-]{4,39}$/i;
  function findCode() {
    var forms = document.querySelectorAll('.needsclick.kl-private-reset-css-Xuajs1, [data-testid="POPUP"], [role="dialog"]');
    for (var i = 0; i < forms.length; i++) {
      var walker = document.createTreeWalker(forms[i], NodeFilter.SHOW_TEXT);
      for (var n = walker.nextNode(); n; n = walker.nextNode()) {
        var t = n.nodeValue.trim();
        if (CODE_RE.test(t)) return t;
      }
    }
    return '';
  }
  function applyCode(code) {
    if (readStore(sessionStorage).applied === code) return;
    writeStore(sessionStorage, { applied: code });
    log('applying code', code);
    origFetch && origFetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).catch(function () {});
  }
  // Every submit (the "Yes" step, then the email step) watches the next 30s for the code to appear.
  var codeObserver, codeTimer;
  function watchForCode() {
    if (!window.MutationObserver) return;
    var done = function () { if (codeObserver) codeObserver.disconnect(); codeObserver = null; clearTimeout(codeTimer); };
    var check = function () { var c = findCode(); if (c) { done(); applyCode(c); } };
    if (!codeObserver) {
      codeObserver = new MutationObserver(check);
      codeObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    clearTimeout(codeTimer);
    codeTimer = setTimeout(done, 30000);
    check();
  }

  var local = readStore(localStorage);
  var recentlyClosed = local.closedAt && Date.now() - local.closedAt < CLOSE_DAYS * 864e5;
  if (window.Shopify && Shopify.designMode) stop('theme editor');
  else if (/^\/(cart|checkouts?)(\/|$)/.test(location.pathname)) stop('cart page');
  else if (cartCount > 0) stop('cart has items');
  else if (local.submitted) stop('already signed up');
  else if (recentlyClosed) stop('closed within ' + CLOSE_DAYS + ' days');
  else if (readStore(sessionStorage).shown) stop('already shown this visit');

  /* ---------- Watch preview renders and add-to-cart ---------- */
  function onPreview(type, reason, id) {
    // Other scripts (fbm-save-preview.js, fbm-posthog.js) listen for these. reason only comes with 'fail':
    // http-<status>, edge-no-id, status-3 or network. id = Teeinblue's upload id when the request URL has one.
    document.dispatchEvent(new CustomEvent('fbm:preview', { detail: { type: type, reason: reason, id: id || '' } }));
    // Once they upload a photo, "Save your preview" asks for the email instead of this popup.
    if (type === 'start') stop('photo uploaded');
    if (type === 'start') { state.busy = true; state.engaged = true; clearTimeout(quietTimer); log('preview rendering'); }
    else if (type === 'done') { state.busy = false; state.previewReady = true; log('preview ready'); armQuiet(); }
    else if (type === 'fail') { state.busy = false; log('preview failed'); }
  }
  function isCartAdd(url) { return /\/cart\/add(\.js)?(\?|$)/.test(url); }
  function cartAdded() {
    stop('added to cart');
    document.dispatchEvent(new CustomEvent('fbm:cart-add'));
  }
  // What Shopify says was added (one line item, or { items: [...] } for a multi-add), so fbm-posthog.js can tell the
  // product from upsells such as Shipping Protection. items is null when the answer isn't JSON.
  function cartAddedItems(j) {
    var items = j && (Array.isArray(j.items) ? j.items : (j.variant_id ? [j] : null)) || null;
    document.dispatchEvent(new CustomEvent('fbm:cart-added', { detail: { items: items } }));
  }

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      // Teeinblue starts a generation either with the older async call or (since Oct 2026) one genai-uploads POST.
      var edge = /upload\.teeinblue\.com\/[^?#]*genai-uploads/.test(url);
      var starts = edge || /\/customer-uploads\/[^/?]+\/image-filter-effects\/async|\/customer-uploads\/(generate|derive)/.test(url);
      var status = /(photo|snap)-api\.teeinblue\.com\/[^?#]*\/image-filter-effects\/status/.test(url);
      var rid = (url.match(/\/customer-uploads\/([^/?#]+)\//) || [])[1];
      if (starts) onPreview('start', undefined, rid);
      // A refused start (e.g. 429 = hourly preview limit) or a failed status poll ends the render too, or listeners
      // would wait forever. Other photo-api requests (upload URLs, error logs, the device-fingerprint "thumbmark") are
      // no render of their own: their failure sends nothing, or listeners would end a render that is still running.
      if (starts || status) {
        p.then(function (r) {
          if (!r.ok) { onPreview('fail', 'http-' + r.status, rid); return; }
          // An edge answer without an upload id (or with no JSON) ends that attempt as well: Teeinblue then retries
          // with a presigned upload, whose render sends its own start.
          if (edge) { r.clone().json().then(function (j) { if (!j || !j.id) onPreview('fail', 'edge-no-id'); }, function () { onPreview('fail', 'edge-no-id'); }); return; }
          if (!status) return;
          r.clone().json().then(function (j) {
            if (j && j.status === 2) onPreview('done', undefined, rid);
            else if (j && j.status === 3) onPreview('fail', 'status-3', rid);
          }).catch(function () {});
        }, function () { onPreview('fail', 'network', rid); });
      }
      if (isCartAdd(url)) p.then(function (r) {
        if (!r.ok) return;
        cartAdded();
        try { r.clone().json().then(cartAddedItems, function () { cartAddedItems(null); }); } catch (e) { cartAddedItems(null); }
      }, function () {});
      return p;
    };
  }
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartAdd(String(url))) {
      this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 300) return;
        cartAdded();
        var j = null;
        try { j = this.responseType === 'json' ? this.response : JSON.parse(this.responseText); } catch (e) { /* not JSON */ }
        cartAddedItems(j);
      });
    }
    return xhrOpen.apply(this, arguments);
  };

  /* ---------- Personalizing = touching the product options / photo form ---------- */
  var CUSTOMIZER = '.tee-form-wrapper, .fbm-pf-frame, .fbm-pz, [data-plp-name-choice], ' +
    '[data-plp-buy] label, [data-plp-buy] input, [data-plp-buy] select, [data-plp-buy] textarea, ' +
    'main form[action*="/cart/add"] input, main form[action*="/cart/add"] select, main form[action*="/cart/add"] label, ' +
    'main variant-radios, main variant-selects';
  function markEngaged(e) {
    // Only real taps / keys count: scripts preselect options with label.click(), whose change events look trusted.
    if (!e.isTrusted) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var hit = e.type === 'change' ? t.matches('input[type=file]') : t.closest(CUSTOMIZER);
    if (hit && !state.engaged) { state.engaged = true; clearTimeout(firstTimer); clearTimeout(maxTimer); clearInterval(retryTimer); log('started personalizing'); }
  }
  ['pointerdown', 'keydown', 'change'].forEach(function (type) { document.addEventListener(type, markEngaged, true); });
  // Choosing a photo counts even when a script forwards the file (Pawlight's drop zone), so no isTrusted check.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('main input[type=file]')) stop('photo uploaded');
  }, true);

  /* ---------- Only open when nothing else is going on ---------- */
  function visible(el) { return !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden'; }
  function whyNotNow() {
    if (document.visibilityState !== 'visible') return 'tab hidden';
    if (document.documentElement.classList.contains('fbm-save-open')) return 'save sheet open';
    if (state.busy) return 'preview rendering';
    var a = document.activeElement;
    if (a && a.matches && a.matches('textarea, select, input:not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit])')) return 'typing';
    if (document.documentElement.classList.contains('plp-viewer-open')) return 'style viewer open';
    var drawer = document.querySelector('cart-drawer');
    if (drawer && (drawer.classList.contains('active') || drawer.classList.contains('is-open') || drawer.hasAttribute('open'))) return 'cart drawer open';
    if (document.querySelector('dialog[open], details[open] > .menu-drawer, .menu-drawer-container[open]')) return 'dialog or menu open';
    var tee = document.querySelectorAll('.tee-dialog, .tee-modal');
    for (var i = 0; i < tee.length; i++) if (visible(tee[i])) return 'Teeinblue dialog open';
    if (document.body && /(^|\s)overflow-hidden/.test(document.body.className)) return 'page scroll locked';
    return '';
  }
  window.fbmPopup.whyNotNow = whyNotNow;
  // fbm-save-preview.js: a design restored on reload / from the saved-preview email counts as an upload.
  document.addEventListener('fbm:restored', function () { stop('photo restored'); });

  function open() {
    if (state.stopped || state.opened) return;
    state.opened = true;
    state.openedAt = Math.round(performance.now());
    clearTimeout(firstTimer); clearTimeout(maxTimer); clearTimeout(quietTimer); clearInterval(retryTimer);
    writeStore(sessionStorage, { shown: 1 });
    log('opening form', FORM_ID);
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', FORM_ID]);
  }

  // Try now; if something is in the way, keep checking every second while `stillWanted` holds.
  var retryTimer;
  function openWhenFree(stillWanted) {
    clearInterval(retryTimer);
    var check = function () {
      if (state.stopped || state.opened || !stillWanted()) { clearInterval(retryTimer); return; }
      var why = whyNotNow();
      if (why) { log('waiting:', why); return; }
      clearInterval(retryTimer);
      open();
    };
    check();
    if (!state.opened) retryTimer = setInterval(check, 1000);
  }

  var firstTimer, maxTimer, quietTimer;
  function armQuiet() {
    if (state.stopped || state.opened || !state.previewReady) return;
    clearTimeout(quietTimer); clearInterval(retryTimer);
    quietTimer = setTimeout(function () {
      openWhenFree(function () { return !state.busy; });
    }, AFTER_PREVIEW);
  }
  // Any activity after the preview restarts the quiet countdown.
  ['pointerdown', 'keydown', 'input', 'wheel', 'touchmove', 'scroll'].forEach(function (type) {
    window.addEventListener(type, function () { if (state.previewReady && !state.opened && !state.stopped) armQuiet(); }, { capture: true, passive: true });
  });

  /* ---------- Browsing (not personalizing): wait until they look interested ---------- */
  var maxScrolled = 0;
  function scrolledShare() {
    var room = document.documentElement.scrollHeight - window.innerHeight;
    return room > 0 ? window.scrollY / room : 1;
  }
  function browseOpen(reason) {
    if (state.engaged || state.stopped || state.opened) return;
    clearTimeout(firstTimer); clearTimeout(maxTimer);
    log('interested:', reason);
    openWhenFree(function () { return !state.engaged; });
  }
  function onScroll() {
    maxScrolled = Math.max(maxScrolled, scrolledShare());
    if (state.timeMet && maxScrolled >= MIN_SCROLL) browseOpen('time + scroll');
  }

  if (!state.stopped) {
    log('armed; cart items', cartCount);
    window.addEventListener('scroll', onScroll, { passive: true });
    firstTimer = setTimeout(function () {
      if (state.engaged) { log('personalizing - waiting for the preview'); return; }
      state.timeMet = true;
      onScroll();
      if (!state.opened) log('time met; scrolled', Math.round(maxScrolled * 100) + '%');
    }, MIN_TIME);
    maxTimer = setTimeout(function () {
      if (state.engaged) return;
      browseOpen('max time');
    }, MAX_TIME);
  }
})();
